import React, { Fragment } from 'react'
import { withRouter, matchPath, Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { do_action } from '../../actions'
import { setGroup, setCustomer, setPageSeo } from '../../actions/index'
import ModalSignIn from '../Modal/ModalSignIn'
import ModalRegister from '../Modal/ModalRegister'
import ModalTerm from '../Register/ModalTerm'
import GoogleTranslate from '../Common/GoogleTranslate'
import { Cookies } from 'react-cookie'
// import '../../../../public/css/blog.css';
const cookies = new Cookies()

const pathList = ['/detail', '/room', '/contractor', '/designer-pm', '/confirm']

const getParams = pathname => {
  const matchProfile = matchPath(pathname, {
    path: `/quotes/*/:quote_id`,
  });
  return (matchProfile && matchProfile.params) || {};
};

class Header extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            quote_id: ''
        }
    }

    componentWillMount() {
        let {dispatch} = this.props;
        do_action('get_all_group', {})
            .then(data => {
                if (data.signal) {
                    dispatch(setGroup(data.data));
                } else {
                    return window.location.href = '/';
                }
            })
            .catch(err => console.log(err));

        do_action('page_seo_key', {})
            .then(data => {
                if (data.signal) {
                    dispatch(setPageSeo(data.data));
                }
            })
            .catch(err => console.log(err));

        // const token = cookies.get('customer')
        // if (token) do_action('get_customer_by_token', { token })
        //     .then(data => {
        //         if (data.signal) {
        //             dispatch(setCustomer(data.data.customer))
        //         } else {
        //             cookies.remove('customer', {path : '/', maxAge: 96969696})
        //         }
        //     })
        //     .catch(err => console.log(err))
    }

    getParam = (location) => {
        const modified = location.substring(1, location.length)
        return modified.substring(modified.indexOf('/') + 1, modified.length)
    }

    processPath = (path, idx) => {
        let {quote, location} = this.props;
        if (!quote && path == '/detail') {
            return 'active';
        }

        if (quote) {
            let {pathname} = location;
            let quotes_step = quote.step;
            if (pathname.indexOf(path) >=0 ) {
                return 'active';
            } else {
                if (idx < quotes_step) {
                    return 'activate';
                } else {
                    return '';
                }
            }
        }
    }

    logoutVendor(e) {
        e.preventDefault();
        let {history, dispatch} = this.props;
        cookies.remove('customer', {path : '/', maxAge: 96969696})
        
        dispatch(setCustomer({}))
        // history.push('/')
        window.location.href = '/'
    }

    redirect = (path, idx, e) => {
        e.preventDefault();
        let {quote, history} = this.props;
        if (quote) {
            if (idx <= quote.step) {
                history.push(`/quotes${path}/${quote._id}`);
            }
        }
    }

    render() {
        let {location, customer, dispatch, history, noneRedirect} = this.props;
        console.log(noneRedirect)
        let {pathname} = location;
        let isSuccess = pathname.indexOf('success') >= 0;
        return (
            <Fragment>
            <div className="header header-top">
                <div className="h-top">
                    <div className="container">
                        <ul className="nav navbar-nav navbar-left">
                            <li><GoogleTranslate /></li>
                        </ul>
                        <ul className="nav navbar-nav navbar-right">
                            <li>
                                {/*<Link to="#">
                                    <img src="/images/forum.png" alt="Ruhu" className="ico icon-image"/>
                                    Forums
                                </Link>*/}
                                <Link to="/blogs" className="icon-flex">
                                    <img src="/images/forum.png" alt="Ruhu" className="ico icon-image"/>
                                    Blogs
                                </Link>
                            </li>
                            {(Object.keys(customer).length !== 0) ? (
                                <li>
                                    <a href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" className="lang fontSemiBold">
                                        <img src="/images/user-logo.png" alt="Ruhu" className="avatar mr-5" />
                                        {`Hello ${customer.last_name}`}
                                        <span className="fa fa-angle-down ml-5"></span>
                                    </a>
                                    
                                    <ul className="dropdown-menu dropdown-menu-right">
                                        <li><Link to="/profile">My profile</Link></li>
                                        <li><Link to="/my-quotes">My quotes</Link></li>
                                        <li><a href="#" onClick={this.logoutVendor.bind(this)}>Logout</a></li>
                                    </ul>
                                </li>
                            ) :
                                <Fragment>
                                    <li>
                                        <a href="#" className="h-signin" data-toggle="modal" data-target="#modal-sign-in" data-backdrop="static" data-keyboard="false"><img src="/images/logo-signin.png" alt="Ruhu" className="ico" />Signin</a>
                                    </li>

                                    <li>
                                        <a href="#" data-toggle="modal" data-target="#modal-regis-free" data-backdrop="static" data-keyboard="false" className="h-signin">Sign up</a>
                                    </li>
                                </Fragment>
                            }
                        </ul>
                    </div>
                </div>
            </div >

            <ModalSignIn dispatch={dispatch} history={history}/>

            <ModalRegister dispatch={dispatch} history={history}/>

            <ModalTerm history={history}/>

            {this.props.children}

            {/* <div className="modal fade" id="modal-regis-free" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div className="modal-dialog" role="document">
                    <div className="modal-regis-free">
                        <div className="col-left">
                            <div className="info">
                                <img src={'/images/check.png'} />
                                <div className="text-center">BEST RATES & PRICING</div>
                                <div className="text-center">COMPHREHENSIVE PROFILING</div>
                                <div className="text-center">STANDARDISED & TRANSPARENT</div>
                                <div className="text-center">BIGGEST to SMALLEST<br/>
                                <span>of budgets</span></div>
                            </div>
                            <div className="contact">
                                <img src={'/images/quote.png'} />
                                <div className="text-center">Contact Us !!</div>
                                <div className="text-center">+6563980900</div>
                            </div>
                        </div>
                        <div className="col-right">
                            <div className="title text-center">Sign Up for a Free Membership</div>
                            <div className="sub-title text-center">Create Your Account. It's Free!</div>
                            <div className="form-regis-free">
                                <div className="form-group">
                                    <input type="email" placeholder="Email" name="email_regis_free" className="form-control" />
                                </div>
                                <div className="form-group">
                                    <input type="password" placeholder="Password" name="password_regis_free" className="form-control"/>
                                </div>
                                <div>
                                    <input type="text" placeholder="Contact no" name="contact_regis_free" className="form-control"/>
                                </div>
                                <div className="list-check">
                                    <div className="item-checkbox">
                                        <input id="check_remember" type="checkbox" name="check_remember"/>
                                        <label for="check_remember">Remember me</label>
                                    </div>
                                    <a href="#">Forgot your password</a>
                                </div>
                                <button type="submit" className="submit-form-regis">Register Now!</button>
                                <div className="sign-up-other">
                                    <div className="text-center title">or Sign Up Using</div>
                                    <div className="list-sign-up">
                                        <a href="#" className="facebook"><img src={'/images/facebook.png'} /></a>
                                        <a href="#" className="google"><img src={'/images/google-plus.png'} /></a>
                                    </div>
                                </div>
                            </div>
                            <div className="item-checkbox term">
                                <input id="check_term" type="checkbox" name="check_term"/>
                                <label for="check_term">Please indicate that you have read and agree to the Terms and Conditions and Privacy Policy</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            </Fragment>
        )
    }
}

function mapStateToProps(state) {
    const {customer, quote, pageSeo} = state
    return { quote, customer, pageSeo }
}

export default connect(mapStateToProps)(withRouter(Header))